import { Sparkles, ShoppingBag, Music2, Building2, Cpu, Briefcase, GraduationCap, Boxes, Shield, Coins } from "lucide-react";

// 10 Armada Sectors · EIGOO ecosystem operational territories
export const ARMADA_SECTORS = [
  {
    id: "beauty",
    code: "01",
    name: "Beauty",
    icon: Sparkles,
    tagline: "Private-label skincare, cosmetics, beauty masterclasses.",
    territory: "Pacific Siren · Active Hull",
    status: "Active",
  },
  {
    id: "trade",
    code: "02",
    name: "Trade",
    icon: ShoppingBag,
    tagline: "Direct-to-consumer storefronts, marketplaces, dropship rails.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "music",
    code: "03",
    name: "Music",
    icon: Music2,
    tagline: "Independent label hulls, sync licensing, livestream concerts.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "real-estate",
    code: "04",
    name: "Real Estate",
    icon: Building2,
    tagline: "Pacific listings, luxury rentals, off-market acquisitions.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "cyberops",
    code: "05",
    name: "CyberOps",
    icon: Cpu,
    tagline: "Algorithmic audits, OSINT, paid-traffic warfare.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "b2b-leads",
    code: "06",
    name: "B2B Leads",
    icon: Briefcase,
    tagline: "Verified lead pipelines, outbound fleets, cold-warm-hot signal.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "education",
    code: "07",
    name: "Education",
    icon: GraduationCap,
    tagline: "Course hosting, masterclass production, student rosters.",
    territory: "Beauty War College · Live",
    status: "Active",
  },
  {
    id: "provisions",
    code: "08",
    name: "Provisions",
    icon: Boxes,
    tagline: "Pacific food, beverages, supplements, ritual provisions.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "vanguard",
    code: "09",
    name: "Vanguard",
    icon: Shield,
    tagline: "Security, custom infrastructure, sovereignty operations.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
  {
    id: "treasury",
    code: "10",
    name: "Treasury",
    icon: Coins,
    tagline: "Fintech rails, lineage-split engines, payment infrastructure.",
    territory: "Open Sector · Awaiting Sovereign",
    status: "Open",
  },
];
